export function buildDownloadFileName(title: string | undefined, extension: string, fallbackBase: string): string {
    const sanitized = (title ?? '')
        .trim()
        .replace(/[\\/:*?"<>|]/g, '_')
        .replace(/\s+/g, ' ')
        .trim();
    const base = sanitized || fallbackBase;
    const ext = extension.startsWith('.') ? extension.slice(1) : extension;
    return `${base}.${ext.toLowerCase()}`;
}

export function combineProjectAndConfigurationName(
    projectName: string | undefined,
    configurationName: string | undefined
): string | undefined {
    const combined = [projectName, configurationName]
        .filter(part => !!part && part.trim().length > 0)
        .join('-');
    const result = combined || configurationName;
    return result?.replace(/\s+/g, '_');
}
